import React from "react";
import { Link } from "react-router-dom";

const Index = ({
    className,
    title,
    description,
    linkText = "Voir plus",
    icon,
    isAccount = false,
    cardLink,
}) => {
    return (
        <div className={className}>
            {!isAccount ? (
                <div className="card h-100 border">
                    <div className="card-body">
                        <h2 className="card-title fw-bolder">{title}</h2>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="text-center">
                                    <img style={{ width: "120px" }} src={icon} alt="icon" />
                                </div>
                            </div>
                            <div className=" col-md-8">
                                <p className="text-black">{description}</p>
                                <p className="text-center">
                                    <Link to={cardLink ? cardLink : '/'} className="btn p-0">
                                        <span className="text-black">{linkText}</span>
                                        <span className="text-primary fw-bolder">
                                            <i className="bi bi-arrow-right"></i>
                                        </span>
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    style={{ backgroundColor: "#caebe0" }}
                    className="card h-100 border"
                >
                    <div className="card-body">
                        <div className="card-title row fw-bolder align-items-baseline">
                            <div className="text-center col-2">
                                <img style={{ width: "40px" }} src={icon} alt="icon" />
                            </div>
                            <h3 className="col-10">{title}</h3>
                        </div>
                        <div className="">
                            <div className="text-center">
                                <p className="text-black">{description}</p>
                                <Link to={cardLink} className="btn btn-primary btn-transition">
                                    <span className="text-white">{linkText}</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Index;
